export const saveOrderResults = {
  SANCTIONED: 'sanctioned',
  BLOCKED: 'blocked',
  BLACKLIST: 'blacklist',
  CONTRACT_LIMIT: 'contractLimit',
  RESPONSE_MESSAGE: 'responseMessage',
  ERROR_MESSAGE: 'errorMessage',
  SUCCESS: 'success',
  DECLARED_SUCCESS: 'declaredSuccess',
  UNKNOWN: 'unknown',
  POSSIBLE_MATCH: 'possible_match',
};

export const confirmContractResults = {
  INSUFFICIENT_FUNDS: 'insufficientFunds',
  RESPONSE_MESSAGE: 'responseMessage',
  UNKNOWN: 'unknown',
};

export const otpResults = {
  INVALID: 'invalid',
  SUCCESS: 'success',
};